import { render, staticRenderFns } from "./ClassificationPill.vue?vue&type=template&id=8508ab2e&scoped=true"
import script from "./ClassificationPill.vue?vue&type=script&lang=js"
export * from "./ClassificationPill.vue?vue&type=script&lang=js"
import style0 from "./ClassificationPill.vue?vue&type=style&index=0&id=8508ab2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8508ab2e",
  null
  
)

export default component.exports